{
  "version": 1,
  "asset_id": "621068e5-bba7-4acb-8a13-458f4afd95a2",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/621068e5-bba7-4acb-8a13-458f4afd95a2/sleeve-hiatal-type-1-second-en-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/621068e5-bba7-4acb-8a13-458f4afd95a2/sleeve-hiatal-type-1-second-en-800.webp",
  "original_filename": "sleeve-hiatal-type-1-second-en-800.webp",
  "size": 43478,
  "content_type": "image/webp",
  "created_at": "2026-09-26T22:31:58Z"
}
